/**
 * Equalize heights of all event-card-body elements
 * Finds the maximum height among all event-card-body divs and sets all to that height
 */
function equalizeEventCardBodyHeights() {
  // Find all event-card-body elements within event-cards-grid containers
  const eventCardsGrids = document.querySelectorAll('.event-cards-grid');
  
  eventCardsGrids.forEach((grid) => {
    const cardBodies = grid.querySelectorAll('.event-card-body');
    
    if (cardBodies.length === 0) return;
    
    // Reset heights to auto to get natural heights
    cardBodies.forEach((body) => {
      const bodyElement = /** @type {HTMLElement} */ (body);
      bodyElement.style.height = 'auto';
    });
    
    // Get all heights and find the maximum
    let maxHeight = 0;
    cardBodies.forEach((body) => {
      const bodyElement = /** @type {HTMLElement} */ (body);
      const height = bodyElement.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    // Set all card bodies to the maximum height
    if (maxHeight > 0) {
      cardBodies.forEach((body) => {
        const bodyElement = /** @type {HTMLElement} */ (body);
        bodyElement.style.height = `${maxHeight}px`;
      });
    }
  });
}

// Equalize heights when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Wait a bit for images and content to load
  setTimeout(() => {
    equalizeEventCardBodyHeights();
  }, 100);
  
  // Also equalize after a longer delay to account for lazy-loaded images
  setTimeout(() => {
    equalizeEventCardBodyHeights();
  }, 500);
});

// Equalize heights on window resize
/** @type {ReturnType<typeof setTimeout> | null} */
let resizeTimeout = null;
window.addEventListener('resize', () => {
  if (resizeTimeout !== null) {
    clearTimeout(resizeTimeout);
  }
  resizeTimeout = setTimeout(() => {
    equalizeEventCardBodyHeights();
  }, 250);
});

// Re-equalize when new sections are loaded (for theme editor)
document.addEventListener('shopify:section:load', () => {
  setTimeout(() => {
    equalizeEventCardBodyHeights();
  }, 100);
});

// Make function globally available so it can be called after cards are dynamically added
window.equalizeEventCardBodyHeights = equalizeEventCardBodyHeights;
